import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export const CTABanner = ({ 
  title = "Ready to Lead the Charge?",
  subtitle = "Share your site details and timelines—we'll return with a tailored EV infrastructure plan.",
  primaryCTA = "Start Your Project",
  primaryLink = "/contact",
  secondaryCTA = null,
  secondaryLink = null,
  variant = "dark" // dark or light
}) => {
  const isDark = variant === "dark";

  return (
    <section 
      className={`py-20 md:py-28 ${isDark ? 'cta-dark' : 'bg-slate-50'}`}
      data-testid="cta-banner"
    >
      <div className="container-custom">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className={`text-3xl md:text-4xl lg:text-5xl font-black tracking-tight mb-6 ${
            isDark ? 'text-white' : 'text-slate-900'
          }`}>
            {title}
          </h2>
          <p className={`text-lg md:text-xl mb-10 ${
            isDark ? 'text-slate-300' : 'text-slate-600'
          }`}>
            {subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to={primaryLink}
              className="btn-gradient px-8 py-4 rounded-full font-semibold text-lg inline-flex items-center gap-2 group"
              data-testid="cta-primary-button"
            >
              {primaryCTA}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
            {secondaryCTA && (
              <Link
                to={secondaryLink}
                className={`px-8 py-4 rounded-full font-semibold text-lg border-2 transition-colors ${
                  isDark 
                    ? 'border-white/30 text-white hover:bg-white/10' 
                    : 'border-slate-300 text-slate-700 hover:border-[#00A2B5] hover:text-[#00A2B5]'
                }`}
                data-testid="cta-secondary-button"
              >
                {secondaryCTA}
              </Link>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABanner;
